jQuery(document).ready(function($) {
  if (!$('.how-it-work-new').length) {
    return;
  }

  howItWorksNew($);
  
  if ($(window).width() < 992) {
    var img_count = $('.how-it-work-new-step-image img').length;
    var img_load_counter = 0;
    $('.how-it-work-new-step-image img').each(function(){
      if (this.complete || this.readyState === 4) { //if img in cache
        img_load_counter++;

        if(img_count == img_load_counter){
          changeStylesBlockByHeight();
        }
      } else { //if img not in cache
        $(this).on('load', function(){ 
          img_load_counter++;
              
          if(img_count == img_load_counter){
            changeStylesBlockByHeight();
            }
        }); 
      }
    });
  }
});

function changeStylesBlockByHeight() {
  var height = $('.how-it-work-new-tabs-wrap').outerHeight();
  var heightAll = $('.how-it-work-new-tabs').outerHeight() + $('.how-it-work-new-step').outerHeight() - ($('.how-it-work-new-step1').outerHeight()/3);
  console.log($('.how-it-work-new-tabs').outerHeight());
  console.log($('.how-it-work-new-step').outerHeight());
  console.log($('.how-it-work-new-step1').outerHeight()/3);
  console.log(heightAll);
  $('.how-it-work-new-tabs-link').css('width',  + (height / 3 - 10) + 'px');
  $('.how-it-work-new-tabs-link').css('margin-left', '-' + (height / 3 - 10) + 'px');
  $('.how-it-work-new-tabs-content').css('min-height', + height + 'px');
  $('.how-it-work-new-step-json.mobile').css('max-height', + heightAll + 'px');
}

function howItWorksNew($) {
  $('.how-it-work-new-tabs .how-it-work-new-tabs-link').click(function(){
		var tab_id = $(this).attr('data-tab');
    var tab_bottom_id = $(this).attr('data-bottom-tab');

		$('.how-it-work-new-tabs .how-it-work-new-tabs-link').removeClass('how-it-work-new-tabs-link-active');
		$('.how-it-work-new-tabs-content').removeClass('how-it-work-new-tabs-content-active');
    $('.how-it-work-new-tabs-content-bottom').removeClass('how-it-work-new-tabs-content-bottom-active');

		$(this).addClass('how-it-work-new-tabs-link-active');
		$('#'+tab_id).addClass('how-it-work-new-tabs-content-active');
    $('#'+tab_bottom_id).addClass('how-it-work-new-tabs-content-bottom-active');    
	})
}



// WEBPACK FOOTER //
// ./scripts/blocks/how-it-works-new.js